export default __webpack_public_path__ + "static/media/The-People-Champ.fd2bbb86.gif";